import React from "react";
import { View, StyleSheet } from "react-native";
import NtText from "../../../components/NtText";
import colors from "../../../config/colors";

function NtSectionTitle({ style, ...otherProbs }) {
  return <NtText style={[styles.text, style]} {...otherProbs} />;
}

const styles = StyleSheet.create({
  container: {},
  text: {
    color: "white",
    fontSize: 20,
    fontWeight: "600",
    textAlign: "center",
  },
});

export default NtSectionTitle;
